import * as React from 'react';
import {
  Text,
  TextTag,
  TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import {DisclaimerReference} from '../disclaimer/disclaimer-reference';
import {RowDescription} from './multi-table/getDescriptions';

export const RowHeader = (props: {row: RowDescription}) => {
  const {row} = props;
  return (
    <>
      <Text tag={TextTag.span} wordBreak bold>
        {row.label}
      </Text>

      {row.debugText && (
        <>
          <br></br>
          <Text tag={TextTag.span} appearance={TokenTextAppearance.copy100}>
            {row.debugText}
          </Text>
        </>
      )}
      <DisclaimerReference disclaimerKey={row.disclaimerKey} />
    </>
  );
};
